import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { ToastrService } from '@shared-angular/services/toastr.service';



@Component({
  selector: 'app-skill-id-input',
  templateUrl: './skill-id-input.component.html',
  styleUrl: './skill-id-input.component.scss',
  imports: [NgClass,  FormsModule, TooltipModule, InputTextModule]
})
export class SkillIdInputComponent {
  constructor(private toastr: ToastrService) { }

  public readonly readonly = input<boolean>(false);
  public readonly value = input<string>('');
  public readonly changed = output<string>();

  public copyToClipboard(text: string) {
    void navigator.clipboard.writeText(text);
    this.toastr.info("SKILLID_COPIED");
  }

  public change(value: string): void {
    value = value.split(' ').join('');
    value = value.replace(/[^a-zA-Z0-9]/g, '');
    value = value.replace(/^\d+/, ''); // Remove leading digits


    /* Hier könnten wir Pattern ansetzen welche
    die skillId validieren und ggf. korrigieren.
    value = value.replace(/\s+/g, '');

    value = value.replace(/^\d+/, '');
    */
    this.changed.emit(value);
  }
}
